module.exports = __webpack_public_path__ + "avg-daily-rate.png?00423d76bad1d5165945ef392d79eb7b";